const globalTransition = "0.25s";

const theme = {
  verdant: {
    background: '#B2FF5A',
    primary: '#40522D',
    secondary: '#00BB10',
    tertiary: '#FFFFFF',
    quaternary: '#c2b280',
    globalTransition,
  },
  crescent: {
    background: '#222831',
    primary: '#393e46',
    secondary: '#4b5d67',
    tertiary: '#32e0c4',
    quaternary: '#d54062',
    globalTransition,
  },
  icy: {
    background: '#9DD1F1',
    primary: '#759EDC',
    secondary: '#8cc',
    tertiary: '#C8E0F4',
    quaternary: '#508AA8',
    globalTransition,
  },
  rad: {
    background: '#9F00FF',
    primary: '#F70D1A',
    secondary: '#00AAEE',
    tertiary: '#FFE302',
    quaternary: '#FF5F00',
    globalTransition,
  },
  spring: {
    background: '#3D3B30',
    primary: '#5C80BC',
    secondary: '#E7E247',
    tertiary: '#3D3B30',
    quaternary: '#FFC09F',
    globalTransition,
  },
  sapphire: {
    background: 'blue',
    primary: '#67d',
    secondary: '#4ae',
    tertiary: '#FFFFFF',
    quaternary: '#031927',
    globalTransition,
  },
  arcade: {
    background: '#111111',
    primary: '#3d266b',
    secondary: 'chartreuse',
    tertiary: '#961414',
    quaternary: '#336590',
    globalTransition,
  },
  winter: {
    background: '#FFFFFF',
    primary: 'gray',
    secondary: '#444',
    tertiary: '#000000',
    quaternary: '#5c5c5c',
    globalTransition,
  },
  desert: {
    background: '#ffcdb2',
    primary: '#6d6875',
    secondary: '#b5838d',
    tertiary: '#e5989b',
    quaternary: '#ffb4a2',
    globalTransition,
  },
};

export default theme;
